export const COLORS = {
    primaryColor: '#2A5B69'
}